<template>
  <v-container>
  <v-row >
    <v-col cols="6" lg="8" md="8"  sm="11" v-if="windowWidth>600"  style=" text-align: -webkit-right;">
      <v-img

          class="shrink mr-2"
          src="~@/assets/images/Group87 (1).svg"
          style="margin-top:30px;height: 250px;width: 289px; margin-right: 20% !important;"
      >

      </v-img>
      <div >
        <img src="~@/assets/images/slide1.jpg" class="image1">
      </div>

    </v-col>
    <v-col md="4" lg="4" sm="11" cols="12" v-bind:class="windowWidth>600?'formStyle':''">
      <v-img
          v-if="windowWidth>600"
          class="shrink mr-2"
          src="~@/assets/images/Group183.svg"
          style="margin-top:30px;height: 250px;width: 289px; margin-right: -4% !important;"
      >
      </v-img>

      <div v-bind:class="windowWidth>600?'image2':'alineCenter'" >
        <div class="telegraficoFont" v-if="windowWidth>600" style="font-size: 30px">
          C O N T A C T <span class="telegraficoFont" style="margin-left: 10px">U S</span>
        </div>
        <div class="telegraficoFont" v-if="windowWidth<600" style="margin-top:10px;font-size: 20px">
          CONTACTUS
        </div>
        <div v-bind:class="windowWidth>600?'descriptionC':'descriptionM'" >letters, as opposed to using there packages desktop publishing packages and page web
          page use Lorem
        </div>
        <div v-bind:class="windowWidth>600?'formFieldC':'formFieldM'">
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
            <v-text-field
                label="Full Name"
                class="fieldH"
                v-model="full_name"
                :rules="nameRules"
                outlined
            ></v-text-field>
            <v-text-field
                label="Email"
                class="fieldH"
                v-model="email"
                :rules="emailRules"
                outlined
            ></v-text-field>
            <v-text-field
                label="Phone Number"
                class="fieldH"
                v-model="phoneNumber"
                :rules="phoneRules"
                outlined
            ></v-text-field>
            <v-textarea
                 style="height: 120px"
                 height="110"
                 v-model="message"
                label="Write you message"
                required
                outlined
            >

            </v-textarea>
          </v-form>
          <div style="text-align: center">
            <v-btn height="25px" width="100"
                   @click="validate()"
                   v-bind:style="valid?'background-color: #FFFFFF!important;color: black!important':'background-color: gray!important;color: black!important'"
                   style="border-radius:5px;">
              send
            </v-btn>
          </div>
        </div>

      </div>

    </v-col>
  </v-row>
    <v-snackbar
        v-model="snackbar"
    >
      Your Message Has Been Sent
      <template v-slot:action="{ attrs }">
        <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import {contactUs} from "@/shared/orderService";

export default {
  name: "contactUs",
  data(){
    return{
      valid: false,
      snackbar: false,
      windowWidth: window.innerWidth,
      full_name:null,
      nameRules: [
        v => !!v || 'Name is required'
      ],
      email:null,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      phoneNumber:null,
      phoneRules:[
        v => !!v||'phone is required',
        v=> (v && v.length === 10)||'phone must be 10 number'
      ],
      message:null
    }
  }, methods: {
    validate() {
      if(this.$refs.form.validate()){
        const data = {
          full_name: this.full_name,
          phone_number: this.phoneNumber,
          email: this.email,
          message: this.message
        };
        contactUs(data).then(() => {
          this.snackbar = true;
          this.$refs.form.reset();
        });
      }
    },
  }
}
</script>

<style scoped>
.image2 {
  text-align: initial;
  position: absolute;
  top: 15%;
  width: 43%;
  left: 60%;
}

::v-deep .theme--dark.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset{
  color: whitesmoke;
  border-radius: 10px;
}
.fieldH{
  height: 65px !important;
}
::v-deep .v-label{
  font-size: 12px;
}
.image1{
  width: 37%;
  height: 65%;
  position: absolute;
  left: 13%;
  top: 8%;
}
.formStyle{
  text-align: -webkit-right;
}
.formFieldC{
  max-width: 55%;

  margin-top: 40px
}
.formFieldM{
  max-width: 80%;
  margin-top: 30px;
  margin-left: 10%;
}
.alineCenter{
  text-align: center;
}
.descriptionC{
  max-width: 70%
}
.descriptionM{
  max-width: 95%;
  font-size: 15px;
  margin-top: 10px;
}

</style>
